import {AfterViewInit, Directive, ElementRef} from '@angular/core';

declare var $: any;

@Directive({
             selector: '[appFoundation]'
           })
export class FoundationDirective implements AfterViewInit {

  constructor(public elementRef: ElementRef) {
  }

  ngAfterViewInit(): void {
    $(this.elementRef.nativeElement).foundation();
  }
}
